import React, { useEffect, useState, useRef } from "react";
import config from "../../config";
import { triggerNotification } from "../../component/message/Msg";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import Spinner from "../../component/loadingbar/Spinner";
import TableViewer from "../../component/tableViewer/TableViewer";

const ViewPackages = () => {
  const { token, user_type } = config;
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [packages, setPackages] = useState([]);

  //  ------For TableViewer ------
  const packagesRef = useRef([]);
  packagesRef.current = packages;
  const [rowData, setRowData] = useState([]);
  //  ------For TableViewer ------
  //----------------------------------------------- select / view packages table  -------------------------------------------------R
  // Fetch all packages
  const fetchPackages = async () => {
    setLoading(true);
    try {
      await fetch(`${config.host_url}packages`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            setPackages(data.data);

            //  ------For TableViewer ------
            const packagesData = data.data.map((pkg) => ({
              package_name: pkg.pkg_name,
              icon: pkg.pkg_display_icon,
              priority: pkg.pkg_priority,
              type: pkg.pkg_type,
              catagory: pkg.pkg_catagory_name,
              idNumber: pkg.pacakge_id,
            }));
            setRowData(packagesData);
            //  ------For TableViewer ------
            // console.log(data.data);
          } else if (data.status === 401) {
            // Invalid token
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error fetching packages.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchPackages();
  }, [token]);

  // ------------------------------------------------- View  package ---------------------------------------------------- U
  const btnShowHandle = (pkid) => {
    const encodedId = window.btoa(encodeURIComponent(pkid));
    navigate(`/viewpackage/${encodedId}`);
  };

  // ------------------------------------------------- Edit / Update package ---------------------------------------------------- U
  const btnEditHandle = (id) => {
    const encodedId = window.btoa(encodeURIComponent(id));
    navigate(`/addpackage/${encodedId}`);
  };

  // ---------------------------------------------------- Delete package ---------------------------------------------------------D
  // Show a confirmation dialog
  const btnDeleteHandle = (deleteId, i) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to delete package. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDeletePackage(deleteId, i);
      }
    });
  };

  //If confirm then delete package
  const handleDeletePackage = async (deleteId, i) => {
    try {
      await fetch(`${config.host_url}packages/${deleteId}`, {
        method: "DELETE",
        headers: {
          token: token,
        },
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data.status === 200) {
            triggerNotification("success", "Package deleted successfully");

            //  ------For TableViewer ------
            const updatedPackage = [...packagesRef.current];
            updatedPackage.splice(i, 1);
            setPackages(updatedPackage);
            const packagesData = updatedPackage.map((pkg) => ({
              package_name: pkg.pkg_name,
              icon: pkg.pkg_display_icon,
              priority: pkg.pkg_priority,
              type: pkg.pkg_type,
              catagory: pkg.pkg_catagory_name,
              idNumber: pkg.pacakge_id,
            }));
            setRowData(packagesData);
            //  ------For TableViewer ------
          } else if (data.status === 404) {
            console.error("Package IDs not found");
            triggerNotification("error", "Package IDs not found");
          } else if (data.status === 401) {
            // Invalid Token
            console.error("Invalid token");
            triggerNotification("error", "Unauthenticated User");
          } else {
            // Internal Server Error or other HTTP errors
            console.error("Internal server error");
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        });
    } catch (error) {
      console.error("Error deleting package:", error);
      triggerNotification("error", "Error deleting package");
    }
  };

  //  ------For TableViewer ------
  const colDefs = [
    {
      headerName: "#",
      width: 50,
      valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },
    {
      headerName: "Package",
      field: "package_name",
      width: 300,
      cellRenderer: (params) => (
        <div className=" flex py-1 ">
          <img
            src={params.data.icon}
            alt="Teacher_Image"
            className="rounded h-11 w-11  mr-4"
          />
          <p className="p-0 m-0">{params.data.package_name}</p>
        </div>
      ),
    },
    { field: "priority", filter: true },
    { field: "type", filter: true },
    { field: "catagory", filter: true },
  ];
  //  ------For TableViewer ------
  return (
    <>
      <Breadcrumb txt="Manage Package" subpath={["View Packages"]} />
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center flex justify-between">
            <h5 className="mb-0">View Packages</h5>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                navigate("/addpackage");
              }}
            >
              Add Package
            </button>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="px-3 pb-3  table-responsive">
              <TableViewer
                rowData={rowData}
                colDefs={colDefs}
                onEdit={btnEditHandle}
                onDelete={btnDeleteHandle}
                onView={btnShowHandle}
                // haveImage
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewPackages;
